export default "/images/d51afee6290290ccde5fb9cee99f9f2a.avif";